/**
 * Responsible for validating a field so that it simulates a user interacting
 * with a field.
 * @module elements/fields/validate-field
 */
import $ from 'jquery';
import isNil from 'lodash/isNil';

import registerJQueryPlugin from '../../lib/register-jquery-plugin';

const VALIDATE_FIELDS_DEFAULTS = {
  val: null,
  retainFocus: true,
};

export default function validateField(el, options = {}) {
  const $el = $(el);
  const { val, retainFocus } = Object.assign({}, VALIDATE_FIELDS_DEFAULTS, options);
  const prevActiveElement = document.activeElement;
  if (!isNil(val)) {
    $el.val(val);
  }

  $el
    .trigger('focus')
    .trigger('blur');

  if (retainFocus) {
    $(prevActiveElement).trigger('focus');
  }
}

registerJQueryPlugin('validate', validateField, { cache: false });



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/fields/validate-field.js